<template>
  <div class="confirm-dialog">
    <p class="confirm-dialog__message">{{ message }}</p>
    <div class="confirm-dialog__buttons">
      <label @click="emits('cancel')">{{ cancelText }}</label>
      <label @click="emits('confirm')">{{ confirmText }}</label>
    </div>
  </div>
</template>

<script setup lang="ts">

interface Props {
  message: string
  confirmText: string
  cancelText: string
}

const props = defineProps<Props>()
const emits = defineEmits<{
  (event: 'confirm'): void,
  (event: 'cancel'): void,
}>()
</script>

<style lang="scss">
.confirm-dialog {
  width: 450px;
  height: 130px;
  padding: 24px 34px 24px 34px;
  color: $white;
  border: 1px solid $grey-80;
  border-radius: 4px;
  display: flex;
  flex-flow: column;
  border-left: 8px solid $warning-orange;
  background-color: $black;
  color: $white;
  text-align: center;
  justify-content: center;

  &__message {
    font-size: 16px;
    font-family: $font-medium;
    line-height: 20px;
  }

  &__buttons {
    font-family: $font-regular;
    margin-top: 15px;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    flex-direction: row;
    width: 358px;
    
    label {
      cursor: pointer;
      margin: auto;
      color: $link-blue
    }
  }
}
</style>
